import { Slot as SlotPrimitive } from 'radix-ui';
export const Root = SlotPrimitive.Root;
export const Slot = SlotPrimitive.Root;
export const Slottable = SlotPrimitive.Slottable;
